import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import Seo from "../components/seo"
import { LocalBusinessJsonLd } from 'gatsby-plugin-next-seo';

import Header from "../components/header"
import Story from "../components/story"
import Uryslygi from "../components/uryslygi"
import Sdelka  from "../components/sdelka"
import Price from "../components/price"
import Catalog from "../components/catalog"

import OtzivAudio from "../components/otzivAudio"
import OtzivVideo from "../components/otzivVideo"
import OtzivSocial from "../components/otzivSocial"
import OtzivBlank from "../components/otzivBlank"
import OtzivMap from "../components/otzivMap"
import Social from "../components/social"
import Certificate from "../components/certificate"
import Users from "../components/users"

import Blog from "../components/blog"
import Text from "../components/text"
import Map from "../components/map"

import ContactForm from "../components/contactForm"
import Call from "../components/call"
import Sale from "../components/sale"
import CallForm from "../components/callForm"
import Stado from "../components/stado"
import Policy from "../components/policy"

export const query = graphql `
	query  {
		blogs: allBlog(sort: { order: DESC, fields: datePublished }, limit: 10) {
			edges {
			  node {
				slug
				title
				description
				card
				img
				imgMini
				date
				seoTitle
				seoDescription
				author
				ava
				time
			  }
			} 
		}
	}
`

const IndexPage = ({data}) => {
	return (
		<Layout>
			<Seo title="Представление интересов в государственных органах | Юридическая компания | Алмаз" description="! ⚖️ «Алмаз» ➥ ⭐ В состав услуги входит защита прав граждан или юридических лиц в правоотношениях с государственными учреждениями, службами, правоохранительными и контролирующими органами. " />

			<LocalBusinessJsonLd
				type='Store'
				id='https://юридические-услуги-казань.рф/predstavlenie-interesov-v-gosudarstvennyh-organah'
				name="Представление интересов в государственных органах | Юридическая компания | Алмаз"
				description="! ⚖️ «Алмаз» ➥ ⭐ В состав услуги входит защита прав граждан или юридических лиц в правоотношениях с государственными учреждениями, службами, правоохранительными и контролирующими органами. "
				url='https://юридические-услуги-казань.рф'
				telephone='+78005519518'
				address={{
					streetAddress: 'Щапова, 26',
					addressLocality: 'Казань',
					addressRegion: 'Татарстан',
					postalCode: '420012',
					addressCountry: 'RU',
				}}
				geo={{
					latitude: '55.791461',
					longitude: '49.136606',
				}}
				images={[
					'https://юридические-услуги-казань.рф/img/logo.png'
				]}
			/>

			<Header title="Представление интересов в государственных органах" card="Сомневаетесь, что хороший юрист Вам по карману? Не знаете, как подготовиться к судебному процессу и защитить свои права? Запутались в законах и не знаете, как грамотно сформулировать претензию ?" />
			<Story />
			<Uryslygi />
			<Sdelka />
			<Price />
			<Catalog />
			<OtzivAudio />
			<OtzivVideo />
			<OtzivSocial />
			<OtzivBlank />
			<OtzivMap />
			
			<Social />
			<Certificate />
			<Users />

			<Blog data={data.blogs} />

			<Text 
				title={"Представление интересов в государственных органах"}
			
				html={

				`
				<p class="TextText">
					<b>Представление интересов в государственных органах в Казани</b>
				</p>

				<p class="TextText">
					<img alt="Агентство недвижимости Алмаз" class="uk-preserve uk-margin-small-right TextSvg" src="/svg/map.svg" width="16" height="16" uk-svg-map="true"></img>
					Услуга по представлению интересов в государственных органах в Казани доступна юридическим лицам, индивидуальным предпринимателям, простым гражданам (физическим лицам). Юристы Алмаз оказывают эффективную юридическую помощь в решении различных споров, оформлению документов, защите прав клиентов.
				</p>

				<p class="TextText">
					<img alt="Агентство недвижимости Алмаз" class="uk-preserve uk-margin-small-right TextSvg" src="/svg/map.svg" width="16" height="16" uk-svg-map="true"></img>
					Компания Алмаз оказывает услуги по предоставлению интересов граждан и юридических лиц в государственных органах в Казани. В состав услуги входит защита прав граждан или юридических лиц в правоотношениях с государственными учреждениями, службами, правоохранительными и контролирующими органами.
				</p>

				<p class="TextText">
					<b>Представление интересов граждан</b>
				</p>

				<p class="TextText">
					<img alt="Агентство недвижимости Алмаз" class="uk-preserve uk-margin-small-right TextSvg" src="/svg/map.svg" width="16" height="16" uk-svg-map="true"></img>
					Физические лица периодически вынуждены обращаться государственные учреждения и организации. Этот процесс иногда осложняется взаимоотношениями между гражданами и государственными служащими. Непонимание нормативной базы и официального языка приводит к затяжному решению многих простых вопросов. Часто бюрократические проволочки длятся месяцами. Специалисты нашей компании смогут помочь каждому гражданину и решить проблемы более оперативно.
				</p>

				<p class="TextText">
					<b>Услуги по выполнению поручений и представлению интересов граждан включают</b>
				</p>

				<p class="TextText">
				Сбор и оформление документов во всех государственных учреждениях и организациях
				</p>

				<p class="TextText">
				Составление заявлений и обращений граждан в правоохранительные и контролирующие органы
				</p>

				<p class="TextText">
				Разрешение спорных ситуаций
				</p>

				<p class="TextText">
				Обжалование действий государственных служащих и решений государственных органов в отношении физических лиц
				</p>

				<p class="TextText">
					<b>Взаимоотношения с клиентами</b>
				</p>

				<p class="TextText">
					<img alt="Агентство недвижимости Алмаз" class="uk-preserve uk-margin-small-right TextSvg" src="/svg/map.svg" width="16" height="16" uk-svg-map="true"></img>
					У нас работают специалисты высокого класса. Обширная юридическая практика позволяет решать сложные вопросы, достигать выгодного результата для каждого клиента в соответствии с действующим законодательством.
				</p>

				<p class="TextText">
					<img alt="Агентство недвижимости Алмаз" class="uk-preserve uk-margin-small-right TextSvg" src="/svg/map.svg" width="16" height="16" uk-svg-map="true"></img>
					Вы можете позвонить в компанию Алмаз и записаться на предварительную консультацию. На встречу необходимо принести все документы, имеющие отношение к данной проблеме. Юридическая помощь будет намного эффективнее, если Вы заранее сформулируете свою проблему и волнующие вопросы.
				</p>

				`

			}/>

			<Map />

			<ContactForm />
			<Sale />
			<Call />
			<CallForm />
			<Stado />
			<Policy />
		</Layout>
	)
}


export default IndexPage
